import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import "../App.css";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/infrastructure", label: "Infrastructure" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" }
];

function Navbar({ onOpenQuote }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setIsOpen(false)}>
          <img src="/assets/svplogo.jpeg" alt="Sai Venkateshwara Packages logo" />
          <div>
            <span>SAI VENKATESHWARA PACKAGES</span>
            <small>Industrial Packaging Manufacturers</small>
          </div>
        </Link>

        <button type="button" className="navbar-hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          <span className="navbar-bar"></span>
          <span className="navbar-bar"></span>
          <span className="navbar-bar"></span>
        </button>

        <div className={`navbar-menu ${isOpen ? "open" : ""}`}>
          <ul className="navbar-links">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="btn btn-primary navbar-cta"
            onClick={() => {
              setIsOpen(false);
              onOpenQuote();
            }}
          >
            Get Quote
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
